module.exports = __webpack_public_path__ + "img/ez-slot-category-fishing-game.09903f89.png";